<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、活动管理列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col
            :xs="8"
            :sm="6"
            :md="4"
            :lg="3"
            :xl="2"
          >
            <el-input
              v-model="masterList.tableQuery.search.phone"
              placeholder="请输入电话"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
      />
    </div>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列活动管理）
import TableOperation from '@/components/TableOperation'
// 列表活动管理tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 数据请求
import { loadAppConsumerGroupBuyPhoneErrorListListDataApi, loadAppConsumerGroupBuyPhoneErrorListExportDataApi } from '@/api/appConsumerGroupBuyPhoneErrorList'

export default {
  name: 'AppConsumerGroupBuyPhoneErrorList',
  components: {
    CustomTable,
    TableOperation
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'app_consumer_group_buy_phone_error_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['app_consumer_group_buy_phone_error_list_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            phone: '',
          }
        }
      },
      id: null, // 选中的单据ID
      eventType: '',
      dialogTaskVisible: false,
      dialogViewTitle: '',
      dialogViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'orderNo', filterColumn: 'o.order_no', label: '订单编号', width: 140 },
      { prop: 'orderDateStr', filterColumn: 'o.order_date', label: '订单日期', width: 140, isBetween: true },
      { prop: 'consumerName', filterColumn: 'r.name', label: '消费者名称', width: 120 },
      { prop: 'phone', filterColumn: 'l.phone', label: '电话号码', width: 160 },
      { prop: 'groupBuyStoreName', filterColumn: 'i.store_name', label: '团购零售户名称', width: 160 },
      { prop: 'benxiangStoreName', filterColumn: 'ifnull(b.store_name, \'\')', label: '本香门店名称', width: 160 },
      { prop: 'benxiangCertificateNo', filterColumn: 'ifnull(b.certificate_no, \'\')', label: '本香专卖证号', width: 160 },
      { prop: 'storeName', filterColumn: 'ifnull(s.store_name, \'\')', label: '睿零售门店名称', width: 160 },
      { prop: 'certificateNo', filterColumn: 'ifnull(s.certificate_no, \'\')', label: '睿零售专卖证号', width: 160 },
      { prop: 'errorTypeStr', filterColumn: 'l.error_type', filterValue: 'errorType', label: '异常类型', width: 120, filterArray: [{ label: '本香号码存在', value: 1 }, { label: '睿零售档案号码存在', value: 2 }] },
      { prop: 'errorMsg', filterColumn: 'l.error_msg', label: '异常说明', width: 260 },
      { prop: 'remark', filterColumn: 'l.remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'l.operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'l.operation_time', label: '操作时间', width: 160, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadAppConsumerGroupBuyPhoneErrorListListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadAppConsumerGroupBuyPhoneErrorListExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
